<template>
  <ul>
    <li :class="{'active_media_category': getCategoryActive('') }">
      <a
        class="button button--default"
        @click="setCategoryId('')"
      >
        {{ buttonText }}
      </a>
    </li>
    <li
      v-for="(categoria, index) in getMediaLibraryCategoria"
      :key="index"
      :class="{'active_media_category': getCategoryActive(categoria.ID) }"
    >
      <a
        class="button button--default"
        @click="setCategoryId(categoria.ID)"
      >{{ categoria.Name }}</a>
    </li>
  </ul>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'media-library-filter',
  props: {
    buttonText: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      getMediaLibraryCategoria: 'getMediaLibraryCategoria',
      getCategoryId: 'getCategoryId',
      getCategoryActive: 'getCategoryActive'
    })
  },
  methods: {
    ...mapMutations({
      setCategoryId: 'setCategoryId'
    })
  }
}
</script>
